// apps/web/src/pages/reservation/operations.ts — Phase 03 plan 03-04.
//
// Public GraphQL operations for the guest reservation wizard. The two
// public queries (availability, slots) are reachable WITHOUT an
// Authorization header per the server contract in plan 03-02; the
// gqlRequest wrapper in lib/api.ts only attaches Authorization when
// an in-memory access token is present, so the X-Lang header is the
// only one this client sends on a public call.
//
// Stable operation names ("Availability", "Slots") are required by
// the 401-retry interceptor in lib/api.ts and by the test mocks
// (mockRequest matches by `getOperationName(doc)`).

import { gql } from "graphql-request";

export const AVAILABILITY_QUERY = gql`
  query Availability($month: String!) {
    availability(month: $month) {
      date
      state
      reasons
      freeSlotsCount
    }
  }
`;

export const SLOTS_QUERY = gql`
  query Slots($date: String!) {
    slots(date: $date) {
      id
      startTime
      durationMinutes
      startsAt
      endsAt
      remainingSeats
      weekday
    }
  }
`;
